import { render, staticRenderFns } from "./TakePayment.vue?vue&type=template&id=1b2d0f5f"
import script from "./TakePayment.vue?vue&type=script&lang=js"
export * from "./TakePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports